import { extend } from 'umi-request'
import { apiUrl } from '../utils/url'
import { sign } from '@feedback/utils/util'
import qs from 'qs'
import request, { handleUrlParams } from '@feedback/utils/request'
import { getVestSiteDomainPayload } from '@feedback/utils/siteConfig'

/**
 * @des  路由全放在参数的action字段中
 */
// const handleUrlParams = () => {
//   // console.log(window.location)
//   // debugger
//   const hashParams = qs.parse(window.location.hash.split('?')[1])
//   const { appid, did } = hashParams
//   if (hashParams && appid && did) {
//     window.localStorage.setItem('headerFromApp', JSON.stringify(hashParams))
//     return hashParams
//   } else {
//     const paramsObj = window.localStorage.getItem('headerFromApp')
//     return paramsObj ? JSON.parse(paramsObj) : {}
//   }
// }

// 处理头部加密相关
const handlerSignHeader = (otherParams = {}) => {
  const ts = Math.floor(new Date().getTime() / 1000).toString()
  const nonce = Math.random().toString().slice(0, 6)
  // const { appid } = handleUrlParams() || {}
  return {
    ...handleUrlParams?.(),
    // 测试 W
    // ...(appid === 'cm1015' && { appid: 'cm1001' }), // TODO: 需要删除
    ts,
    nonce,
    sign: sessionStorage.getItem('sign') || ''
  }
}

/**
 * 生成 Sign
 */
export const getSign = (data = {}): Promise<{ data: { data: string } }> => {
  return request('/open/avg/create', {
    method: 'post',
    data
  })
}

// const request = extend({
//   prefix: apiUrl,
//   headers: {
//     ...handleUrlParams()
//   },
//   timeout: 15000
// })
// 获取反馈列表
export const getFeedbackList = (params?: {
  page?: number
  limit?: number
  status?: number
}) => {
  //{ page, limit }: { page: number; limit: number }
  const data = { action: 'feedback.list', ...params } //page, limit,
  return request(`/api`, {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}
// 获取反馈详情（回复详情）
export const getFeedbackDetail = ({
  feedback_id,
  page,
  limit
}: {
  feedback_id: string
  page: number
  limit?: number
}) => {
  const data = { feedback_id, page, limit, action: 'reply.replyList' }
  return request(`/api`, {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

// 获取faq列表
export const getFaqList = (params?: {
  page?: number
  limit?: number
  search?: string
}) => {
  const data = { action: 'faq.list', ...params }
  return request(`/api`, {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

// 唤起评分
export const feedbackRatingStart = (params: { feedback_id?: string }) => {
  const data = { action: 'feedback.isShow', ...params }
  return request(`/api`, {
    method: 'POST',
    headers: handlerSignHeader(data),
    data
  })
}

// 保存评分
export const feedbackRatingSave = (params: {
  feedback_id: string
  score: number
}) => {
  const data = { action: 'feedback.saveScore', ...params }
  return request(`/api`, {
    method: 'POST',
    headers: handlerSignHeader(data),
    data
  })
}

interface paramsFaqDetail {
  faq_id: string
}

// 获取faq详情
export const getFaqDetail = ({ faq_id }: paramsFaqDetail) => {
  const data = { faq_id, action: 'faq.info' }
  return request(`/api`, {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

export const getFAQRecommend = (params: { faq_id?: string }): Promise<any> => {
  const data = { ...params, action: 'faq.getFaqTipList' }
  return request('/api', {
    method: 'POST',
    headers: handlerSignHeader(data),
    data
  })
}

export const getFAQCountHelp = ({ faq_id }: { faq_id: string }) => {
  const data = { faq_id, action: 'faq.countHelp' }
  return request('/api', {
    method: 'POST',
    headers: handlerSignHeader(data),
    data
  })
}

interface paramsFaqStar {
  faq_id: string
}

interface paramsFaqUnStar {
  faq_id: string
  /**
   * 马甲站不满意反馈原因（原型 dissatisfaction-sheet）。
   * 仅在有输入时透传；后端字段以服务端确认为准，无字段时忽略不影响点踩。
   */
  comment?: string
}

// faq详情点赞
export const setFaqStar = ({ faq_id }: paramsFaqStar) => {
  const data = { faq_id, action: 'faq.star' }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}
// faq详情点踩
export const setFaqUnStar = ({ faq_id, comment }: paramsFaqUnStar) => {
  const data = {
    faq_id,
    action: 'faq.unstar',
    ...(comment ? { comment } : {})
  }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

interface paramsReplay {
  feedback_id: string
  reply_content?: string
  push_user_type: number
  image_upload_key?: string
  spm_error?: string
}

// 添加回复
export const addReply = ({
  feedback_id,
  reply_content,
  push_user_type,
  image_upload_key,
  spm_error
}: paramsReplay) => {
  const data = {
    feedback_id,
    reply_content,
    push_user_type,
    image_upload_key,
    spm_error,
    action: 'reply.add'
  }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

interface paramsComment {
  feedback_id: string
  comment?: string
  star: number
}

// 添加评论
export const addComment = ({ feedback_id, comment, star }: paramsComment) => {
  const data = {
    feedback_id,
    comment,
    star,
    action: 'feedback.comment'
  }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

function handleFile(files: any[]): any[] {
  const targetFile: any[] = []
  files.forEach((item: any) => {
    targetFile.push(item.file)
  })
  return targetFile
}

export interface paramsUploadFile {
  files: any
  type?: string
}

export interface OSSFile {
  expires_in: number
  upload_key: string
}

// 上传文件
export const uploadFile = ({ files, type = '3001' }: paramsUploadFile) => {
  const formData = new FormData()
  const objData: any = {}
  handleFile(files).forEach((item: any, index: number) => {
    formData.append(`files[${index}]`, item)
  })
  formData.append('type', type)
  objData.type = type
  return request('/api/v1/upload/oss', {
    headers: handlerSignHeader(objData),
    method: 'post',
    body: formData,
    timeout: 100 * 1000
  })
}

interface paramsFeedbackConfig {
  question_id?: string
}

// 获取反馈表单参数
export const getFeedbackConfig = ({ question_id }: paramsFeedbackConfig) => {
  const data = {
    question_id,
    action: 'feedback.config'
  }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

// 获取反馈表单问题类型
export const getFeedbackType = () => {
  const data = { action: 'feedback.configType' }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

interface paramsForm {
  formParams: any
}

// 提交反馈表单（马甲站附带 site_domain，既有 app 不带）
export const submitFeedbackForm = (formParams: paramsForm) => {
  const data = {
    action: 'feedback.add',
    ...formParams,
    ...getVestSiteDomainPayload()
  }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

interface paramsColseFeedback {
  feedback_id: string
}

// 关闭反馈表单
export const closeFeedback = ({ feedback_id }: paramsColseFeedback) => {
  const data = {
    feedback_id,
    action: 'feedback.close'
  }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

export interface paramsFeedbackInfo {
  feedback_id: string
}

// 获取反馈表单详情
export const getFeedbackInfo = ({ feedback_id }: paramsFeedbackInfo) => {
  const data = {
    feedback_id,
    action: 'feedback.info'
  }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

// 获取反馈表单详情
export const getFaqListAll = () => {
  const data = { action: 'faq.typeList' }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}
// 获取未读replay数量
export const getNoReadReplay = () => {
  const data = { action: 'reply.hasNoReadReply' }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

// 测试sign
// export const getSign = () => {
//   const data = {
//     action: 'reply.add',
//     reply_content: '4444',
//     push_user_type: 1,
//     feedback_id: '5fd96b81719a0734035ec865'
//   }
//   const ts = '1608088330'
//   const nonce = '0.7601'
//   return request('/sign', {
//     method: 'post',
//     headers: {
//       ts,
//       nonce,
//       sign: sign({ ts, nonce, otherParams: data })
//     },
//     data
//   })
// }

// 用户上报行为接口
export const reportApi = (params: any = {}) => {
  const data = {
    action: 'userActionLog.add',
    ...params
  }
  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

// 新的上报函数，适配 J项目、AVG 4.0
export const trackingApi = (params: any = {}) => {
  const data = {
    action: 'userActionLog.addLog',
    ...params
  }

  return request('/api', {
    method: 'post',
    headers: handlerSignHeader(data),
    data
  })
}

// 一级问题分类下拉选项
export const getQusTypeList = (params: any = {}) => {
  const data = {
    ...params,
    action: 'feedback.getQusTypeList'
  }
  return request('/api', {
    method: 'POST',
    headers: handlerSignHeader(data),
    data
  })
}

// 二级分类问题下拉选项
export const getQusList = (params: any = {}) => {
  const data = {
    ...params,
    action: 'feedback.getQusTypeById'
  }
  return request('/api', {
    method: 'POST',
    headers: handlerSignHeader(data),
    data
  })
}

// 根据问题分类 ID 获取所属所有的问题分类信息
export const getQusTypeInfo = (params: any = {}) => {
  const data = {
    ...params,
    action: 'feedback.getQusTypeInfo'
  }
  return request('/api', {
    method: 'POST',
    headers: handlerSignHeader(data),
    data
  })
}

// 网络日志上报
export const addNetworkLog = (params: any = {}) => {
  const data = {
    ...params,
    action: 'userActionLog.addNetworkLog'
  }
  return request('/api', {
    method: 'POST',
    headers: handlerSignHeader(data),
    data
  })
}
